import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ChevronDoubleRightBold } from '@sorare/core/src/atoms/icons/ChevronDoubleRightBold';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { textAnimation } from '@sorare/core/src/components/congratulations/ui';

const StyledBrandM = styled(BrandM).attrs({
  bold: true,
})`
  color: var(--c-yellow-400);
  text-shadow: 0 0 4px rgba(240, 206, 29, 0.6);
`;

const BoostedOddsContainer = styled(Horizontal).attrs({
  center: true,
})`
  padding: var(--double-unit) var(--double-unit) var(--quadruple-unit);
  opacity: 0;
  &.show {
    ${textAnimation}
    opacity: 1;
  }
`;

const ChevronDoubleUp = styled(ChevronDoubleRightBold)`
  color: var(--c-yellow-400);
  transform: rotate(-90deg);
`;

export const BoostedOdds = ({ show }: { show: boolean }) => {
  return (
    <BoostedOddsContainer className={show ? 'show' : ''}>
      <ChevronDoubleUp />
      <StyledBrandM className="text-center">
        <FormattedMessage defaultMessage="Boosted Odds" />
      </StyledBrandM>
      <ChevronDoubleUp />
    </BoostedOddsContainer>
  );
};
